import { render, staticRenderFns } from "./SysMicroComponentForm.vue?vue&type=template&id=5bac384d&"
import script from "./SysMicroComponentForm.vue?vue&type=script&lang=js&"
export * from "./SysMicroComponentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bac384d')) {
      api.createRecord('5bac384d', component.options)
    } else {
      api.reload('5bac384d', component.options)
    }
    module.hot.accept("./SysMicroComponentForm.vue?vue&type=template&id=5bac384d&", function () {
      api.rerender('5bac384d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/micro/modules/SysMicroComponentForm.vue"
export default component.exports